import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../..';

type InitialStateUserContract = {
  data: [];
  companyId: number | undefined;
  status: string;
  error: string | undefined;
};

const initialStateUserContract: InitialStateUserContract = {
  data: [],
  companyId: undefined,
  status: 'idle',
  error: ''
};

export const userContractSlice = createSlice({
  name: 'userContract',
  initialState: initialStateUserContract,
  reducers: {
    addCompanyIdInitial: (state: any, action: PayloadAction<number | undefined>) => {
      state.companyId = action.payload;
    }
  }
});

export const { addCompanyIdInitial } = userContractSlice.actions;
export const userContractSelector = (state: RootState) => state.userContract;
export default userContractSlice.reducer;
